import { parseWithZod } from "@conform-to/zod";
import { ActionFunction, json, redirect } from "@remix-run/node";
import { resetPasswordForEmail } from "@figment-fitness/database/auth";
import config from "./.server/constant/config";
import { auth } from "~/lib/auth.server";
import { medicalRoutes, medicalActions } from "~/utils/medical/routes";
import { SendResetPasswordEmailForm } from "@figment-fitness/ui/features/auth/send-reset-password-email-form";
import { SendResetPasswordEmailSchema } from "@figment-fitness/ui/features/auth/schema";

export const action: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const submission = parseWithZod(formData, {
    schema: SendResetPasswordEmailSchema,
  });

  if (submission.status !== "success") {
    return json({
      success: false,
      error: "エラーが発生しました",
      submission: submission.reply(),
    });
  }

  const { error } = await resetPasswordForEmail(auth, request, {
    email: submission.value.email,
    redirectTo: config.ORIGIN,
  });

  if (error) {
    return json({
      success: false,
      error: error.message,
      submission: submission.reply(),
    });
  }

  throw redirect(medicalRoutes.authSendPasswordResetEmailSuccess());
};

export default function AuthSendResetPasswordEmail() {
  return (
    <SendResetPasswordEmailForm
      sendResetEmailActionPath={medicalActions.authSendPasswordResetEmail()}
    />
  );
}
